import React from "react";

import { SUPPORTED_LANGUAGES } from "../../i18n";
import { getLngIcon } from "./flags/helper";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import { useAuth } from "../authentication/useAuth";
import Popup from "../popup/Popup";

interface Props {
  compact?: boolean;
  className?: string;
}

const LanguageSwitcher: React.FC<Props> = (props): React.ReactElement => {
  const { t } = useCustomTranslation();
  const { language, setLanguage } = useAuth();

  if (!language) {
    return <div />;
  }

  const getLngName = (lng: string) => {
    if (props.compact) {
      return t(lng.toLowerCase());
    }

    return t(`${lng.toLowerCase()}_name`);
  };

  return (
    <Popup
      trigger={
        <div
          className={`border-gray-accent text-primary flex cursor-pointer flex-row items-center rounded-lg border-1 p-2 ${props.className}`}
        >
          <div className="border-gray50 mr-2 w-6 rounded-s border-1">
            {getLngIcon(language)}
          </div>
          <span className="text-secondary text-[14px] font-medium tracking-[-0.28px]">
            {getLngName(language)}
          </span>
        </div>
      }
      position="bottom center"
    >
      {(close) => (
        <div className="p-0.5">
          {SUPPORTED_LANGUAGES.map((lng) => (
            <div
              key={lng}
              className={`flex cursor-pointer flex-row items-center p-1.5 ${lng === language ? "bg-gray50 rounded-md" : ""}`}
              onClick={() => {
                setLanguage(lng);
                close();
              }}
            >
              <div className="border-gray50 mr-2 w-6 rounded-s border-1">
                {getLngIcon(lng)}
              </div>
              <span className="text-secondary text-[14px] font-medium tracking-[-0.28px]">
                {getLngName(lng)}
              </span>
            </div>
          ))}
        </div>
      )}
    </Popup>
  );
};

export default LanguageSwitcher;
